var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useEffect, useMemo, useState } from 'react';
import useWidgetStore, { CurrentTabEnum } from '../../../stores/widgetStore';
import useConfigStore from '../../../stores/configStore';
import QuoteLoading from '../Policy/QuoteLoading';
import QuoteSummary from '../QuoteInfo/QuoteSummary';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import useLatestQuotesWithPolicies from '../../../hooks/useLatestQuotesWithPolicies';
import PolicyStepsHeader from '../../common/PolicyStepsHeader';
import DownloadIcon from '../../icons/DownloadIcon';
import DocumentSign from './DocumentSign';
import useCustomerStore from '../../../stores/customerStore';
import useProductStore from '../../../stores/productStore';
import api from '../../../api';
import { RotateLoader } from 'react-spinners';
var PolicyDocuments = function () {
    var _a;
    var _b = useState(false), isReviewMode = _b[0], setIsReviewMode = _b[1];
    var _c = useState({
        url: null,
        formKey: null
    }), docDetails = _c[0], setDocDetails = _c[1];
    var queryClient = useQueryClient();
    var latestQuotesWithPolicies = useLatestQuotesWithPolicies(true);
    var _d = useWidgetStore(), selectedQuote = _d.selectedQuote, setSelectedQuote = _d.setSelectedQuote, setCurrentTab = _d.setCurrentTab, setModalOpen = _d.setModalOpen, setActiveDraftQuote = _d.setActiveDraftQuote, setCurrQuestionGroup = _d.setCurrQuestionGroup, setAnswers = _d.setAnswers, setApplicationDataId = _d.setApplicationDataId, setFormActive = _d.setFormActive, setIsEditRequested = _d.setIsEditRequested, isEditRequested = _d.isEditRequested;
    var setProduct = useProductStore().setProduct;
    var extCustomerID = useCustomerStore().extCustomerID;
    var latestQuote = useMemo(function () {
        var latestQuote = latestQuotesWithPolicies.find(function (q) { return q.id === selectedQuote; }) || null;
        var latestPolicy = (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.policy) || null;
        return { latestQuote: latestQuote, latestPolicy: latestPolicy };
    }, [latestQuotesWithPolicies, selectedQuote]).latestQuote;
    var _e = useQuery(['documents', latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id], {
        queryFn: function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, api.quote.getSignatureDocuments({
                            quoteId: latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id
                        })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        }); },
        enabled: !isEditRequested && Boolean(latestQuote && (latestQuote === null || latestQuote === void 0 ? void 0 : latestQuote.id))
    }), policyDocs = _e.data, isLoading = _e.isLoading;
    var allDocsSigned = policyDocs &&
        policyDocs.urls &&
        policyDocs.urls.length > 0 &&
        policyDocs.urls.filter(function (doc) { return doc.key.endsWith('(signed).pdf'); }).length >=
            policyDocs.minSignedDocs &&
        policyDocs.urls.every(function (doc) { return doc.key.endsWith('(signed).pdf'); });
    var _f = useConfigStore(), primaryColor = _f.style.primaryColor, widgetType = _f.keys.widgetType;
    var updateTab = function (e, number) {
        e.preventDefault();
        setCurrentTab(number);
    };
    var closeModalHandler = function () {
        setSelectedQuote(null);
        setModalOpen(false);
        setCurrentTab(CurrentTabEnum.POLICY);
    };
    useEffect(function () {
        if ((policyDocs === null || policyDocs === void 0 ? void 0 : policyDocs.urls) && allDocsSigned && !isLoading) {
            closeModalHandler();
        }
    }, [policyDocs, allDocsSigned]);
    if (!latestQuote) {
        return React.createElement(QuoteLoading, null);
    }
    if (isLoading) {
        return (React.createElement("div", { className: "flex flex-col items-center justify-center min-h-full w-full" },
            React.createElement(RotateLoader, { color: primaryColor, size: 15 }),
            React.createElement("span", { className: "text-2xl font-bold text-center w-full mt-5 text-[#1F2751]" }, "Loading...")));
    }
    var handleEditForm = function (quote) {
        setSelectedQuote(quote.id);
        setModalOpen(true);
        var answers = quote.items.requiredParams;
        setActiveDraftQuote(quote.id);
        setCurrQuestionGroup(0);
        setProduct(quote.product);
        setAnswers(answers);
        setApplicationDataId(quote.externalId);
        setFormActive(true);
        setCurrentTab(CurrentTabEnum.POLICY);
        setIsEditRequested(true);
    };
    return (React.createElement("div", { className: "flex flex-col items-center px-3 md:px-4" },
        React.createElement("div", { className: "sticky top-0 left-0 right-0 w-full bg-white -ml-1 md:-ml-4 z-10" },
            React.createElement(PolicyStepsHeader, { pageName: isReviewMode ? ('Form Application Summary') : (React.createElement("span", { className: "block text-sm sm:text-base md:text-lg lg:text-base pr-2 font-bold leading-tight text-center" }, "Please sign the following forms to submit your application and receive a quote.")), hideNextButton: true, handleClose: closeModalHandler })),
        !isReviewMode && (React.createElement("h1", { className: "text-xs sm:text-sm md:text-base lg:text-lg font-semibold text-gray-600 pt-3 md:pt-4 text-center md:text-left lg:text-center xl:text-left" }, "By signing these forms, you are not committing to the purchase of insurance.")),
        isReviewMode ? (React.createElement(QuoteSummary, { latestQuote: latestQuote, onSign: function () {
                setIsReviewMode(false);
            }, handleBack: function () {
                setIsReviewMode(false);
                setDocDetails({
                    url: null,
                    formKey: null
                });
            } })) : (docDetails === null || docDetails === void 0 ? void 0 : docDetails.url) ? (React.createElement(DocumentSign, { pdfUrl: docDetails.url, extCustomerID: extCustomerID, quoteId: latestQuote.id, formKey: docDetails.formKey, handleClose: function () {
                setDocDetails(null);
                queryClient.invalidateQueries(['documents']);
            }, handleForm: function () { return handleEditForm(latestQuote); } })) : (React.createElement("ul", { className: "grid grid-cols-1 md:grid-cols-2 gap-x-3 md:gap-x-6 gap-y-3 mb-12 pt-5 md:pt-8 w-full max-w-[95vw] md:max-w-none" },
            (policyDocs === null || policyDocs === void 0 ? void 0 : policyDocs.urls) &&
                ((_a = policyDocs.urls) === null || _a === void 0 ? void 0 : _a.map(function (document) {
                    var nameParsed = document.key
                        .split('/')
                        .reverse()[0]
                        .replace('.pdf', '');
                    var isSigned = nameParsed === null || nameParsed === void 0 ? void 0 : nameParsed.endsWith('(signed)');
                    return (React.createElement("li", null,
                        React.createElement("div", { className: "flex items-center justify-between rounded-[12px] md:rounded-[16px] border ".concat(isSigned
                                ? 'bg-green-50 border-emerald-400'
                                : 'bg-[#F5F7FA] border-[#E9EDF7]', " py-2 px-3 gap-3 min-h-[54px] md:min-h-[58px]") },
                            React.createElement("span", { className: "flex items-center gap-x-2" },
                                React.createElement("span", { className: "text-sm sm:text-base md:text-lg lg:text-xl" }, isSigned ? '✅' : '📄'),
                                React.createElement("span", { className: "text-[#1F2751] font-semibold flex-1 text-left text-xs sm:text-sm md:text-base lg:text-lg break-words min-w-0" }, typeof nameParsed == 'string'
                                    ? nameParsed.replace('(signed)', ' (SIGNED)')
                                    : nameParsed)),
                            isSigned ? (React.createElement("a", { href: document.url, target: "_blank", className: "bg-primary h-9 w-9 md:h-10 md:w-10 rounded-[10px] md:rounded-[12px] flex items-center justify-center" },
                                React.createElement(DownloadIcon, null))) : (React.createElement("button", { className: "bg-primary px-3 py-1 text-white font-semibold rounded-lg flex items-center justify-center text-xs sm:text-sm md:text-base lg:text-lg whitespace-nowrap flex-shrink-0 min-w-[100px] sm:min-w-[110px] md:min-w-[120px]", onClick: function () {
                                    setIsReviewMode(true);
                                    setDocDetails({
                                        url: document.url,
                                        formKey: document.key
                                    });
                                } }, "Review & Sign")))));
                })),
            (policyDocs === null || policyDocs === void 0 ? void 0 : policyDocs.urls.length) < policyDocs.minSignedDocs && (React.createElement("div", { className: "col-span-2 flex flex-col items-center justify-start min-h-full w-full mt-4" },
                React.createElement(RotateLoader, { color: primaryColor, size: 8 }),
                React.createElement("span", { className: "text-xl font-bold text-center w-full mt-5 text-[#1F2751]" }, "Fetching More docs...")))))));
};
export default PolicyDocuments;
